<div class="bg-white rounded-2xl box-shadow-1 mb-4">
  <div class="flex items-center justify-between px-5 py-3 cursor border-b border-n30 hover:bg-n10 transition-colors rounded-t-2xl"
       (click)="isCollapsed = !isCollapsed">
    <span class="text-sm font-semibold text-n700">{{ title }}</span>
    <i class="ph text-n400 text-base"
       [class.ph-caret-down]="isCollapsed"
       [class.ph-caret-up]="!isCollapsed"></i>
  </div>
  <div [ngbCollapse]="isCollapsed" class="px-5 py-4">
    <ng-content></ng-content>
  </div>
</div>
